import React, {useState, useCallback, useContext, useEffect} from 'react';
import { useForm } from 'react-hook-form';
import { useMutation } from '@apollo/client';
import DataState from 'app/src/components/DataState';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import { Pressable, View, Text } from 'react-native';
import { CREATE_EXPENSE } from './queries';
import { useLazyQuery } from '@apollo/client';
import { formatAssetNameForSelect } from '../../utils/formatAssetName';
import Autocomplete from '../Autocomplete';
import AuthContext from '../../contexts/AuthContext';
import ExpenseLines from './ExpenseLines';
import NewVendor from '../Vendors/new';
import { PageTitle } from '../../elements';
import elRed from '../../styles/colors';
import { PAYMENT_METHODS } from '.';
import moment from 'moment';
import {NewAttachments} from '../Attachments/new';
import EditLinkedAttachment from '../Attachments/LinkedAttachments/edit';

const NewExpense = ({setShowModal, refetch, knownAssetId,
  setClickedExpense, setShowAddExpenseModal, setShowEditExpenseModal,
  newPurchaseOrder
}) => {
  const auth = useContext(AuthContext);
  const [submitting, setSubmitting] = useState();
  const [markAsPaid, setMarkAsPaid] = useState(false);
  const [showAddVendor, setShowAddVendor] = useState(false);
  const [newVendor, setNewVendor] = useState();
  const [assetId, setAssetId] = useState(knownAssetId);
  const [assets, setAssets] = useState();
  const [expenseLines, setExpenseLines] = useState([]);
  const [linkedAttachments, setLinkedAttachments] = useState([]);
  const [createExpense] = useMutation(CREATE_EXPENSE, {
    onCompleted: (response) => {
      if(refetch) {
        refetch();
      }

      if(newPurchaseOrder) {
        window.location.replace(`/purchase-orders/${response.createExpense.expense.id}`)
      }else if(setClickedExpense) {
        setClickedExpense(response?.createExpense?.expense);
        setShowAddExpenseModal(false);
        setShowEditExpenseModal(true);
      }else {
        if(newPurchaseOrder) {
          window.location.replace(`/purchase-orders/${response.createExpense.expense.id}`)
        }else {
          setShowModal(false);
        }
      }
    }
  });

  const onSubmit = useCallback(input => {
    setSubmitting(true);
    if(markAsPaid) {
      input['markAsPaid'] = true;
    }
    if(input['clearedOn']) {
      input['clearedOn'] = moment(input['clearedOn']).format('YYYY-MM-DD');
    }else {
      input['clearedOn'] = null;
    }
    if(input['linkedAttachments']) {
      input['linkedAttachmentAttributes'] = linkedAttachments;
      delete input['linkedAttachments'];
    }
    createExpense({ variables: input });
  });

  const { control, handleSubmit, register, setValue, getValues, watch,
      formState: { errors } } = useForm({
    defaultValues: {
      vendorId: '',
      requestedById: auth?.user?.id,
      invoiceNumber: '',
      description: '',
      newPurchaseOrder: newPurchaseOrder,
      paymentMethod: '',
      paymentReference: '',
      clearedOn: '',
      expenseFiles: [],
      linkedAttachments: []
    }
  });

  const watchFiles = watch('expenseFiles');
  const watchAttachments = watch('linkedAttachments');

  useEffect(() => {
    if(newVendor) {
      setValue('vendorId', newVendor?.id)
    }
  }, [newVendor])

  return (
    <View>
      {submitting ?
        <DataState.Loading /> :
        <View>
          {showAddVendor ?
            <View>
              <PageTitle>Add Vendor</PageTitle>
              <NewVendor
                setShowModal={setShowAddVendor}
                fromNewExpense={true}
                setNewVendor={setNewVendor}
              />
            </View> :
            <View>
              <Autocomplete
                label={'Vendor'}
                placeHolder={''}
                defaultValue={newVendor || ''}
                resource={'Vendor'}
                setValue={setValue}
                name='vendorId'
                {...register("vendorId", {
                  required: "Required",
                })}
              />
              <Pressable
                onPress={() => setShowAddVendor(true)}
              >
                <Text><span style={{color: elRed}}>+</span> Add New Vendor</Text>
              </Pressable>
              <br/>
              <Input.Text
                label="Invoice Number:"
                name="invoiceNumber"
                control={control}
                errors={errors}
              />
              {!newPurchaseOrder &&
                <Input.Text
                  label="Description:"
                  name="description"
                  control={control}
                  errors={errors}
                />
              }
              <View
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  marginLeft: '-2px',
                  marginBottom: '10px'
                }}
              >
                <input
                  type='checkbox'
                  onChange={() => setMarkAsPaid(!markAsPaid)}
                />
                <Text
                  style={{fontSize: '16px', marginLeft: '5px'}}
                >
                  Mark As Paid?
                </Text>
              </View>
              {markAsPaid &&
                <View>
                  <Input.Picker
                    label="Payment Method:"
                    name="paymentMethod"
                    options={PAYMENT_METHODS.map(type => {
                      return { value: type, label: type }
                    })}
                    control={control}
                    errors={errors}
                  />
                  <Input.Text
                    label="Payment Reference:"
                    name="paymentReference"
                    control={control}
                    errors={errors}
                  />
                  <Input.Date
                    label="Cleared On:"
                    name="clearedOn"
                    control={control}
                    errors={errors}
                  />
                </View>
              }
              {checkDisabled() &&
                <View>
                  <Text
                    style={{
                      color: elRed,
                      fontWeight: 'bold',
                      marginBottom: '10px'
                    }}
                  >
                    Receipt must be uploaded or linked when marking as paid.
                  </Text>
                </View>
              }
              <Text
                style={{marginBottom: '-15px', fontSize: '16px'}}>
                Expense Files:
              </Text>
              {/* <br />
                {expense.expenseFiles && expense.expenseFiles.map(file =>
                  <View style={{width: 'fit-content'}}>
                    <Link to={file.url} target='_blank'>
                      <Text>
                        {file.filename}
                      </Text>
                    </Link>
                  </View>
                )} */}
              <NewAttachments
                recordId={null}
                recordType='Expense'
                attachmentType='Expense File'
                refetch={refetch}
                name='expenseFiles'
                setValue={setValue}
                existingFiles={[]}
              />
              <View>
                <b>OR</b>
                <EditLinkedAttachment
                  linkedAttachments={linkedAttachments}
                  resourceId={null}
                  resourceType={'Expense'}
                  setValue={setLinkedAttachments}
                  multi={true}
                />
              </View>
              <ButtonContainer>
                <ButtonGroup>
                  <Button
                    label="Create Expense"
                    onPress={handleSubmit(onSubmit)}
                    disabled={checkDisabled()}
                    style={{opacity: checkDisabled() ? 0.5 : 1}}
                  />
                </ButtonGroup>
              </ButtonContainer>
            </View>
          }
        </View>
      }
    </View>
  )

  function checkDisabled() {
console.log('linkedAttachments', linkedAttachments)
    return markAsPaid && !(watchFiles?.length || linkedAttachments?.length)
  }
}

export default NewExpense;
